import {
  type BlazeSchema,
  createArrayOfObjectsSchemaFromColumns,
  type DatasetColumn,
} from '@blaze-shared/schema-domain';

const TAG_ITEM_COLUMNS: DatasetColumn[] = [
  { name: 'value', columnType: 'String', dataType: 'String', isProfilePicture: false },
  { name: 'id', columnType: 'String', dataType: 'String', isProfilePicture: false },
  { name: 'backgroundColor', columnType: 'String', dataType: 'String', isProfilePicture: false },
  { name: 'foregroundColor', columnType: 'String', dataType: 'String', isProfilePicture: false },
];

export function createTagItemsSchema(tagColumn: DatasetColumn): BlazeSchema {
  const schema = createArrayOfObjectsSchemaFromColumns(tagColumn.name || 'tags', TAG_ITEM_COLUMNS);
  // Preserve the tag definition so consumers (e.g. color palettes) can still access it
  schema.columns[0].tagDefinition = tagColumn.tagDefinition;
  return schema;
}

export function createColumnValueSchema(column: DatasetColumn): BlazeSchema {
  return { id: '', name: '', columns: [{ ...column, name: '' }] };
}
